import './vertical-media-object.scss';
